export const getDateStringFromDates = (startDate: string, endDate: string | boolean): string => {

    // Date conversion arrays
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const startDateD = new Date(startDate);

    const endDateD = (typeof endDate === "string") ? new Date(endDate) : "";

    // If end Date is false (No end date specified)
    if (!(endDateD instanceof Date)) {
        // Tuesday, August 15
        return `${days[startDateD.getDay()]}, ${startDateD.getDate()} ${months[startDateD.getMonth()]}`
    }

    if (startDateD.getMonth() === endDateD.getMonth()) {
       //13 - 15 November 
       return `${days[startDateD.getDay()]} ${startDateD.getDate()} - ${days[endDateD.getDay()]} ${endDateD.getDate()} ${months[startDateD.getMonth()]}`;
    }

    // 29 Aug - 3 Sept
    return `${startDateD.getDate()} ${monthsShort[startDateD.getMonth()]} - ${endDateD.getDate()} ${monthsShort[endDateD.getMonth()]}`

}